import { render } from "./editOrderRequestForm.vue?vue&type=template&id=5b535bf6&scoped=true"
import script from "./editOrderRequestForm.vue?vue&type=script&lang=js"
export * from "./editOrderRequestForm.vue?vue&type=script&lang=js"

import "./editOrderRequestForm.vue?vue&type=style&index=0&id=5b535bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b535bf6"]])

export default __exports__